import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { COMPETITIONS } from "../../GraphQL/competitions";
import { useSetRecoilState } from "recoil";
import { ActiveCampaign } from "../../State/campaign";

export const CompetitionViewModel = ({ activeOnly = false } = {}) => {
  const [error, setError] = useState<boolean>(false);
  const setActiveCampaign = useSetRecoilState(ActiveCampaign);

  const { loading, data } = useQuery(COMPETITIONS, {
    variables: {
      activeOnly,
    },
    onError: () => {
      setError(true);
    },
  });

  useEffect(() => {
    if (data?.competitions[0]) {
      setActiveCampaign(data?.competitions[0]);
    }
  }, [data, setActiveCampaign]);

  return { data, loading, error };
};
